import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import colors from './colors.js';
import {renderContentfulRichContent} from "./App.js";

const useStyles = makeStyles(theme => ({
  about: {
    padding: theme.spacing(6),
    paddingTop: theme.spacing(3 + 8),
    color: colors.blue,
    width: "100%",
    backgroundColor: colors.pink,
    "& a": {
      color: "inherit",
      textDecoration: "underline",
      "&:hover": {
        color: colors.darkerBlue
      }
    }
  },
}));


export const About = (props) => {
  const classes = useStyles();
  return (
    <Grid container justify="center" className={classes.about} >
      <Grid item xs={12} sm={6}>
        <Typography align="left" variant="h3" paragraph>
          About Us
        </Typography>
        {props.aboutCopy?.aboutContentBody?.content?.map(node => (
          <>
            {node.nodeType === "heading-6" ?
              <Typography align="left" variant="body1">
                  {renderContentfulRichContent(node)}
              </Typography>
            :
              <Typography align="left" variant="body1" paragraph>
                {renderContentfulRichContent(node)}
              </Typography>
            }
          </>
        ))}
      </Grid>
    </Grid>
  );
}
